/* tslint:disable */
/* eslint-disable */
/**
 * OU-AAO API
 * This is a definition of Osaka University AAD Application API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: t.shinohara@mmj.ne.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FinishRequest
 */
export interface FinishRequest {
  /**
   *
   * @type {string}
   * @memberof FinishRequest
   */
  password: string
}

export function FinishRequestFromJSON(json: any): FinishRequest {
  return FinishRequestFromJSONTyped(json, false)
}

export function FinishRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinishRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    password: json['password'],
  }
}

export function FinishRequestToJSON(value?: FinishRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    password: value.password,
  }
}
